/* Svensk katalog for locale-company-rest-mode-no.js.
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('sv', {
  'onb.restMode.step': 'Bolag i viloläge',
  'onb.restMode.title': 'Ska bolaget stå i viloläge?',
  'onb.restMode.help': 'Viloläge är för norska aktiebolag utan ordinarie verksamhet. Plumme följer banken, bokför tillåtna räntor och bankavgifter och förbereder obligatoriska inlämningar.',
  'onb.restMode.yes': 'Ja, ansök om viloläge',
  'onb.restMode.yesHelp': 'Vi startar kvalificeringen och ber om bankanslutning, ingående balans och nödvändiga fullmakter.',
  'onb.restMode.no': 'Nej, använd vanlig lösning',
  'onb.restMode.noHelp': 'Alla ordinarie sidor och arbetsflöden blir tillgängliga.',
  'onb.restMode.conditions': 'Alla bankkonton måste anslutas. Räntor och ordinarie bankavgifter är tillåten passiv aktivitet. Annan bokföringsaktivitet stoppar automatiken och kräver byte till vanlig lösning. Signaturer och fullmakter kan fortfarande krävas.',
  'onb.bank.restModeConnection': 'Viloläge aktiveras inte förrän alla bolagets bankkonton är anslutna. Kontona kan registreras nu, medan själva bankanslutningen slutförs efter att bolaget skapats.',
});
